import { isStreamingAiMessage } from "./streaming-ai-message";

interface TextAnimationMessage {
  readonly _id?: unknown;
  readonly sentAt?: Date | null;
}

export function shouldAnimateTextMessage({
  filteredMessagesLength,
  index,
  isResponder,
  message,
  now = Temporal.Now.instant(),
  readOnly,
  suppressTextAnimationMessageIds,
}: {
  filteredMessagesLength: number;
  index: number;
  isResponder: boolean;
  message: TextAnimationMessage;
  now?: Temporal.Instant;
  readOnly: boolean;
  suppressTextAnimationMessageIds?: ReadonlySet<string>;
}): boolean {
  const oneMinuteAgo = now.subtract({ minutes: 1 });
  const isNewish = message.sentAt
    ? Temporal.Instant.compare(
        oneMinuteAgo,
        Temporal.Instant.from(new Date(message.sentAt).toISOString()),
      ) < 0
    : false;
  const isSyntheticStreamingMessage =
    message._id != null && isStreamingAiMessage({ _id: message._id });
  const isFinalizedStreamingMessage =
    message._id != null &&
    suppressTextAnimationMessageIds?.has(String(message._id)) === true;

  return (
    !readOnly &&
    !isSyntheticStreamingMessage &&
    !isFinalizedStreamingMessage &&
    index === filteredMessagesLength - 1 &&
    isNewish &&
    isResponder
  );
}
